import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import constants from '../constants/annotationSelectionConstants';
import formActionCreators from './formActionCreators';
import reportAnnotationActionCreators from './reportAnnotationActionCreators';
import { legacyRectStringToFormRect, pathStringToPointArray } from '../utils/transformFormAnnotation';
const clearSelection = () => async (dispatch, getState) => {
  const annotationContext = getState().annotationSelection.annotationContext;
  dispatch({
    type: constants.CLEAR_SELECTION,
    annotationContext // will be used in reportAnnotationReducer and annotationReducer
  });
};
const select = annotation => async (dispatch, getState) => {
  const annotationContext = getState().annotationSelection.annotationContext;
  dispatch({
    type: constants.SELECT,
    payload: annotation,
    annotationContext // will be used in reportAnnotationReducer and annotationReducer
  });
};
const setAnnotationContext = context => ({
  type: constants.SET_ANNOTATION_CONTEXT,
  payload: context
});
const setDefaultColor = color => ({
  type: constants.SET_DEFAULT_COLOR,
  payload: color
});
const setClickedEntity = clickedEntity => ({
  type: constants.SET_CLICKED_ENTITY,
  clickedEntity
});
const setSelectableType = function setSelectableType(type) {
  let canEdit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return {
    type: constants.SET_SELECTABLE_TYPE,
    payload: {
      type,
      canEdit
    }
  };
};
const trackCursor = (point, rotation, pageNumber) => ({
  type: constants.TRACK_CURSOR,
  pageNumber,
  rotation,
  point
});
const trackReset = () => ({
  type: constants.TRACK_RESET
});
const startDrawing = () => ({
  type: constants.START_DRAWING
});
const batchChange = changesArray => async (dispatch, getState) => {
  const annotationContext = getState().annotationSelection.annotationContext;
  if (annotationContext === 'report') {
    for (let i = 0; i < changesArray.length; i += 1) {
      const change = changesArray[i];
      // eslint-disable-next-line no-await-in-loop
      await dispatch(reportAnnotationActionCreators.change(change.id, change.path, change.data));
    }
    return;
  }
  if (annotationContext === 'form') {
    // Transform legacy changes to form changes
    const transformed = changesArray.map(change => {
      if (change.path === 'rectString') {
        return _objectSpread(_objectSpread({}, change), {}, {
          path: '/content/render/rect',
          data: legacyRectStringToFormRect(change.data)
        });
      }
      if (change.path === 'inkAnnotation/pathString') {
        return _objectSpread(_objectSpread({}, change), {}, {
          path: '/content/render/pointArray',
          data: pathStringToPointArray(change.data)
        });
      }
      return change;
    });

    // make batch change, the form reducer will update the form and the
    // annotation reducer will handle syncing with display state
    await dispatch(formActionCreators.batchChange(transformed));
    return;
  }
  throw new Error("Unknown annotationContext: ".concat(annotationContext));
};
export default {
  select,
  clearSelection,
  setAnnotationContext,
  setClickedEntity,
  setDefaultColor,
  setSelectableType,
  startDrawing,
  trackReset,
  trackCursor,
  batchChange
};